// src/App.js
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import "./App.scss";

import SignPage from "./pages/SignPage";
import ResetPassword from "./pages/ResetPassword";
import ConfirmReservation from "./pages/ConfirmReservation";
import LegalPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import EnrollFrom from "./pages/EnrollForm";

import ProtectedRoute from "./ProtectedRoute";
import AppShell from "./AppShell";
import { ALLOW } from "./auth/access";

// pages (fără Header în ele)
import SPanel from "./pages/SPanel";
import SPTest from "./pages/SPages/SPTest";
import SPExam from "./pages/SPages/SPExam";
import SPCalendar from "./pages/SPages/SPCalendar";
import SPVideos from "./pages/SPages/SPVideos";

import APanel from "./pages/APanel";
import APInstructors from "./pages/APages/APInstructors";
import APOrarMax from "./pages/APages/APOrarMax";
import APOrarExtreme from "./pages/APages/APOrarExtreme";
import APCalendarExamen from "./pages/APages/APCalendarExamen";
import APInstrGroups from "./pages/APages/APInstrGroups";
import APChatbot from "./pages/APages/APChatbot";
import APExamTicketsAdmin from "./pages/APages/APExamTicketsAdmin";
import APExamCorrection from "./pages/APages/APExamCorrection";
import APTheoryCorrection from "./pages/APages/APTheoryCorrection";
import APAltele from "./pages/APages/APAltele";
import APMessageTemplates from "./pages/APages/APMessageTemplates";
import APInbox from "./pages/APages/APInbox";

import MPanel from "./pages/MPanel";

import PPanel from "./pages/PPanel";
import PPStudents from "./pages/PPanel/PPStudents";
import PPGropus from "./pages/PPanel/PPGroups";
import PPStudentStatistics from "./pages/PPanel/PPStudentStatistics";
import PPTestare from "./pages/PPanel/PPTestare";

import IPanel from "./pages/IPanel";
import IPCalendar from "./pages/IPages/IPCalendar";
import IPOrarPractic from "./pages/IPages/IPOrarPractic";
import IPOrarInterne from "./pages/IPages/IPOrarInterne";
import { preloadUIIcons } from "./components/Common/UIIcon";
import GlobalHapticFeedback from "./components/Common/GlobalHapticFeedback";
import { applyStoredAppearance } from "./utils/appearanceSettings";

// tema și restul aspectului, înainte de prima randare (fără „clipire”)
applyStoredAppearance();

const App = () => {
   React.useEffect(() => {
      preloadUIIcons();
   }, []);

   return (
      <BrowserRouter
         basename="/"
         future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
         }}
      >
         <div className="App">
            <GlobalHapticFeedback />
            <Routes>
               {/* PUBLIC */}
               <Route path="/" element={<SignPage />} />
               <Route path="/enroll" element={<EnrollFrom />} />
               <Route path="/reset-password" element={<ResetPassword />} />
               <Route
                  path="/confirm-reservation/:token"
                  element={<ConfirmReservation />}
               />
               <Route path="/confidentialitate" element={<LegalPage />} />
               <Route path="/termeni" element={<TermsPage />} />

               {/* PROTECTED: Header există O SINGURĂ DATĂ aici */}
               <Route element={<AppShell />}>
                  {/* STUDENT */}
                  <Route
                     path="/student"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.STUDENT}>
                           <SPanel />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/student/test"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.STUDENT}>
                           <SPTest />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/student/exam"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.STUDENT}>
                           <SPExam />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/student/calendar"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.STUDENT}>
                           <SPCalendar />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/student/videoclipuri"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.STUDENT}>
                           <SPVideos />
                        </ProtectedRoute>
                     }
                  />

                  {/* ADMIN */}
                  <Route
                     path="/admin"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APanel />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/inbox"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APInbox />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/instructors"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APInstructors />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/instr-groups"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APInstrGroups />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/orar-max"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APOrarMax />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/orar-extreme"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APOrarExtreme />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/calendarultra"
                     element={<Navigate to="/admin/orar-max" replace />}
                  />
                  <Route
                     path="/admin/interne"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APCalendarExamen />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/bilete"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APExamTicketsAdmin />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/corectare-exam"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APExamCorrection />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/corectare-teorie"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APTheoryCorrection />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/altele"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APAltele />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/mesaje-automate"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APMessageTemplates />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/calendar-examen"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <APCalendarExamen />
                        </ProtectedRoute>
                     }
                  />
                  <Route path="/chatbot" element={<APChatbot />} />
                  <Route
                     path="/admin/chatbot"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.ADMIN}>
                           <Navigate to="/chatbot" replace />
                        </ProtectedRoute>
                     }
                  />

                  {/* MANAGER */}
                  <Route
                     path="/manager"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <MPanel />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/manager/instructors"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <APInstructors />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/manager/instr-groups"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <APInstrGroups />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/manager/orar-max"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <APOrarMax />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/manager/orar-extreme"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <APOrarExtreme />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/manager/calendarultra"
                     element={<Navigate to="/manager/orar-max" replace />}
                  />

                  <Route
                     path="/manager/interne"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.MANAGER}>
                           <APCalendarExamen />
                        </ProtectedRoute>
                     }
                  />

                  {/* PROFESSOR */}
                  <Route
                     path="/professor"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.PROFESSOR}>
                           <PPanel />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/professor/students"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.PROFESSOR}>
                           <PPStudents />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/professor/groups"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.PROFESSOR}>
                           <PPGropus />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/professor/testare"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.PROFESSOR}>
                           <PPTestare />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/professor/student/:studentId/statistics"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.PROFESSOR}>
                           <PPStudentStatistics />
                        </ProtectedRoute>
                     }
                  />

                  {/* INSTRUCTOR */}
                  <Route
                     path="/instructor"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.INSTRUCTOR}>
                           <IPanel />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/instructor/videoclipuri"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.INSTRUCTOR}>
                           <SPVideos />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/instructor/orarul-meu"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.INSTRUCTOR}>
                           <IPCalendar />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/instructor/orar-practice"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.INSTRUCTOR}>
                           <IPOrarPractic />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/instructor/interne"
                     element={
                        <ProtectedRoute allowedRoles={ALLOW.INSTRUCTOR}>
                           <IPOrarInterne />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/instructor/calendar"
                     element={<Navigate to="/instructor/orar-practice" replace />}
                  />
                  <Route
                     path="/instructor/rezervari"
                     element={<Navigate to="/instructor/orar-practice" replace />}
                  />
                  <Route
                     path="/instructor/today"
                     element={<Navigate to="/instructor" replace />}
                  />
               </Route>

               <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
         </div>
      </BrowserRouter>
   );
};

export default App;
